import { observer } from "mobx-react-lite";
import { RecordingView } from "./RecordingView";
import { SettingsPageView } from '../../Pages/settings/SettingsPageView';
import { RecordingsView } from './RecordingsView';
import { DataGoesWhereEventArchiveFormat } from '../../State/EvidenceDB/DatabaseTypes';
import { importRecordingAndDbEventsFromArchive } from '../../State/EvidenceDB/SaveRecording';
import { SerializableError } from "../../lib/utils/SerializedException";
import { WindowRoutingState } from "./WindowRoutingState";
import { ProcessInfo } from "../../State/ProcessInfo";
import { PrivacyPolicy } from "../../Pages/public/PrivacyPolicy";

const listenForDroppedFiles = (windowRoutingState: WindowRoutingState) => {
	const domNode = document.getElementById('root')!;
	// File drop
	domNode.addEventListener('dragover', (event) => {
		event.preventDefault();
		const {dataTransfer} = event;
		if (dataTransfer == null) return;
		// Without this, the drop event won't fire.
		event.preventDefault();
	});


	domNode.addEventListener('drop', async (event) => {
		event.preventDefault();
		const {dataTransfer} = event;
		if (dataTransfer == null) return;
		const {files} = dataTransfer;
		for (let file of files) {
			const json = await file.text();
			ProcessInfo.log(`Read json file of size ${json.length} starting ${json.slice(0, 24)} and ending ${json.slice(-24)}`);
			try {
				const archive = JSON.parse(json) as DataGoesWhereEventArchiveFormat;
				ProcessInfo.log("Parsed archive", archive);
				if (archive != null && typeof archive === 'object' && "events" in archive && Array.isArray(archive.events)) {
					ProcessInfo.log("Importing archive", archive);
					await importRecordingAndDbEventsFromArchive(archive, windowRoutingState.setUploadInProgressPercentage).then(
						(percentDone) => {}
					);		
				}
			} catch (e) {
				alert(`Failed to import ${SerializableError.from(e, "Archive JSON Parser").serialize().message}`);
			} finally {
				windowRoutingState.setUploadInProgressPercentage(undefined);
			}
		}
	});
}

export const PageRouter = observer( ({windowRoutingState}: {windowRoutingState: WindowRoutingState}) => {
	const {recordingViewState, uploadInProgressPercentage} = windowRoutingState;
	if (uploadInProgressPercentage != null) {
		document.title = "Importing into Data Goes Where?";
		return (<div>Importing {uploadInProgressPercentage}% complete</div>);
	} else if (recordingViewState != null) {
		document.title = `${recordingViewState.dbRecordingEntryWriter.nameOrDescription} - Data Goes Where?`;
		return (<RecordingView {...{recordingViewState}} />);
	} else if (windowRoutingState.isSettingsPage) {
		document.title = "Settings - Data Goes Where?";
		return (<SettingsPageView />);
	} else if (windowRoutingState.isPrivacyPolicyPage) {
		document.title = "Privacy Policy - Data Goes Where?";
		return (<PrivacyPolicy />);
	} else { // } if (windowRoutingState.isRecordingsPage) {
		document.title = "Recordings - Data Goes Where?";
		return (<RecordingsView {...{windowRoutingState}} />);
	}
});

export const AppWindow = observer( ({windowRoutingState}: {windowRoutingState: WindowRoutingState}) => {
	listenForDroppedFiles(windowRoutingState);
	return (
			<PageRouter {...{windowRoutingState}} />
	)
});
